const CRAWL_BLOCKED_UTILITY_PATHS = [
  { path: '/cart', match: 'exact' },
  { path: '/search', match: 'exact' },
  { path: '/logout', match: 'exact' },
  { path: '/account', match: 'prefix' },
  { path: '/preview', match: 'prefix' },
  { path: '/undefined', match: 'prefix' },
  { path: '/klaviyo-form', match: 'prefix' },
];

function buildUtilityRobotsDisallowRules() {
  const rules = [];
  for (const { path: utilityPath, match } of CRAWL_BLOCKED_UTILITY_PATHS) {
    if (match === 'exact') {
      rules.push(utilityPath, `/*${utilityPath}`);
      continue;
    }
    rules.push(`${utilityPath}/`, `/*${utilityPath}/`);
  }
  return rules;
}

function isUtilityPathExcluded(normalizedPath) {
  for (const { path: utilityPath, match } of CRAWL_BLOCKED_UTILITY_PATHS) {
    if (match === 'exact' && normalizedPath === utilityPath) {
      return true;
    }
    if (
      match === 'prefix' &&
      (normalizedPath === utilityPath ||
        normalizedPath.startsWith(`${utilityPath}/`))
    ) {
      return true;
    }
  }
  return false;
}

module.exports = {
  CRAWL_BLOCKED_UTILITY_PATHS,
  buildUtilityRobotsDisallowRules,
  isUtilityPathExcluded,
};
